import { HT } from "../siteConfig";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/clinique-logo.png";

const treatmentLinks = [
  { name: "About Hair Transplant", path: "/about-hair-transplants.php" },
  { name: "Male Hair Transplant", path: "/male-hair-transplants.php" },
  { name: "Female Hair Transplant", path: "/female-hair-transplants.php" },
  { name: "Beard Hair Transplant", path: "/beard-hair-transplants.php" },
  { name: "Eyebrow Hair Transplant", path: "/eyebrow-hair-transplants.php" },
  { name: "Body Hair Transplant", path: "/body-hairs-transplants.php" },
  { name: "Hairline Reconstruction", path: "/hairline-reconstruction.php" },
];


const footerLocationGroups = [
  {
    title: "North India",
    cities: [
      "Delhi", "Gurugram", "Noida", "Faridabad", "Chandigarh",
      "Ludhiana", "Amritsar", "Jaipur", "Jodhpur", "Udaipur",
      "Lucknow", "Kanpur", "Varanasi", "Agra", "Dehradun",
    ],
  },
  {
    title: "West & Central India",
    cities: [
      "Mumbai", "Pune", "Nagpur", "Nashik",
      "Chhatrapati Sambhajinagar", "Shirdi", "Kolhapur",
      "Solapur", "Ahmedabad", "Surat", "Vadodara", "Rajkot",
      "Goa", "Indore", "Bhopal",
    ],
  },
  {
    title: "South India",
    cities: [
      "Bangalore", "Mysuru", "Mangaluru", "Hubballi",
      "Chennai", "Coimbatore", "Madurai", "Hyderabad",
      "Visakhapatnam", "Vijayawada", "Kochi",
      "Thiruvananthapuram",
    ],
  },
  {
    title: "East India",
    cities: [
      "Kolkata", "Bhubaneswar", "Patna", "Ranchi",
      "Jamshedpur", "Raipur", "Guwahati", "Siliguri",
    ],
  },
];


const otherLinks = [
  { name: "About Us", path: "/description.php" },
  { name: "Our Team", path: "/our-Surgeons.php" },
  { name: "Training", path: "/trainings.php" },
  { name: "Client Testimonials", path: "/client-testimonials.php" },
  { name: "FAQs", path: "/faq.php" },
  { name: "Male Hair Loss", path: "/male-hair-loss.php" },
  { name: "Female Hair Loss", path: "/female-hair-loss.php" },
  { name: HT.inLabel, path: HT.inPath },
  { name: HT.costLabel, path: HT.costPath },
];

const contactCards = [
  {
    city: "Navi Mumbai (Kharghar)",
    address: "Om Srishthi towers, Sector 20, Kharghar Navi Mumbai, Maharashtra 410210",
    phone: "+91 9082123009",
    phones: ["+91 9082123009", "+91 7506808008"],
  },
  {
    city: "Shirdi",
    address: "Near Shirsath hospital,kacheri cross road,ward no.1, Shrirampur- 413709, Dist. Ahmednagar",
    phone: "+91 8459521438",
  },
  {
    city: "Bangalore",
    address: "Clinique Internationale, Plot No 143, 21st Main Rd, J. P. Nagar, Bengaluru, Karnataka 560078",
    phone: "+91 9900212223",
  },
  {
    city: "Pune",
    address: "Clinique Internationale Saikar's classic, 1st floor PAN Card club Road, Baner, Pune. Pin code- 411045",
    phone: "+91 9049590555",
  },
];

function SocialIcon({ type, href }) {
  const icons = {
    facebook: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="#1a0f02">
        <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5 3.66 9.15 8.44 9.94v-7.03H7.9v-2.91h2.54V9.85c0-2.5 1.49-3.89 3.78-3.89 1.1 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.45 2.91h-2.33V22c4.78-.79 8.44-4.94 8.44-9.94z"/>
      </svg>
    ),
    instagram: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth={1.8}>
        <rect x="3" y="3" width="18" height="18" rx="5"/>
        <circle cx="12" cy="12" r="3.5"/>
        <circle cx="17.2" cy="6.8" r="0.6" fill="#fff" stroke="none"/>
      </svg>
    ),
    youtube: (
      <svg width="17" height="17" viewBox="0 0 24 24" fill="#fff">
        <path d="M21.6 7.2s-.21-1.51-.87-2.17c-.83-.87-1.76-.87-2.19-.92C15.4 4 12 4 12 4h-.01s-3.4 0-6.55.11c-.43.05-1.36.05-2.19.92-.66.66-.87 2.17-.87 2.17S2.16 9 2.16 10.8v1.69c0 1.8.18 3.6.18 3.6s.21 1.51.87 2.17c.83.87 1.92.84 2.41.93 1.75.17 7.43.22 7.43.22s3.4-.01 6.55-.12c.43-.05 1.36-.05 2.19-.92.66-.66.87-2.17.87-2.17s.18-1.8.18-3.6v-1.69c0-1.8-.18-3.6-.18-3.6zM9.96 14.5v-5.6l5.4 2.81-5.4 2.79z"/>
      </svg>
    ),
  };

  const bg = { facebook: "#ffffff", instagram: "linear-gradient(135deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)", youtube: "#ff0000" };

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center justify-center rounded-full transition-transform duration-200 hover:scale-110"
      style={{ width: "38px", height: "38px", background: bg[type] }}
    >
      {icons[type]}
    </a>
  );
}

export default function Footer() {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showFloating, setShowFloating] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setShowScrollTop(window.scrollY > 400);
      setShowFloating(window.scrollY > window.innerHeight * 0.7);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  // WhatsApp message (URL encoded)
  const whatsappMessage = encodeURIComponent("Hello! I'm interested in learning more about your hair transplant services.");
  const whatsappLink = `https://wa.me/919082123009?text=${whatsappMessage}`;

  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700;900&family=Dancing+Script:wght@600&family=Raleway:wght@300;400;500;600&display=swap"
        rel="stylesheet"
      />

      <footer className="relative w-full" style={{ background: "#0a0805" }}>
        <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 pt-16 pb-10">

          {/* ── TOP GRID: logo/about | treatments | other links ── */}
          <div className="grid grid-cols-1 lg:grid-cols-[1.3fr_1fr_1fr] gap-12 lg:gap-10">

            {/* ── COLUMN 1: Logo, working hours, about, socials ── */}
            <div>
              {/* Logo */}
              <div className="mb-7">
                <img src={logo} alt="Clinique Internationale" className="h-16" /> 
                
              </div>

              {/* Working Hours */}
              <div className="mb-6">
                <div className="flex items-center gap-3 mb-3">
                  <span style={{ width: "3px", height: "18px", background: "#c9a84c", display: "inline-block" }} />
                  <h4
                    className="uppercase"
                    style={{ fontFamily: "'Cinzel', serif", fontSize: "15px", letterSpacing: "0.06em", color: "#ffffff" }}
                  >
                    Working Hours
                  </h4>
                </div>
                <div className="flex items-center justify-between" style={{ maxWidth: "320px" }}>
                  <span style={{ fontFamily: "'Raleway', sans-serif", fontSize: "13px", color: "rgba(255,255,255,0.5)" }}>
                    Monday – Sunday:
                  </span>
                  <span style={{ fontFamily: "'Raleway', sans-serif", fontSize: "13px", color: "rgba(255,255,255,0.5)" }}>
                    8:00 am – 8:00 pm
                  </span>
                </div>
              </div>

              {/* About */}
              <div className="mb-6">
                <div className="flex items-center gap-3 mb-3">
                  <span style={{ width: "3px", height: "18px", background: "#c9a84c", display: "inline-block" }} />
                  <h4
                    className="uppercase"
                    style={{ fontFamily: "'Cinzel', serif", fontSize: "15px", letterSpacing: "0.04em", color: "#ffffff" }}
                  >
                    About Clinique Internationale
                  </h4>
                </div>
                <p
                  style={{
                    fontFamily: "'Raleway', sans-serif", fontSize: "13.5px", fontWeight: 300,
                    color: "rgba(255,255,255,0.45)", lineHeight: 1.8, maxWidth: "440px",
                  }}
                >
                  Asia's premium destination for getting a world class hair transplant
                  treatment at affordable cost. Treatments or surgery done at one center
                  can be followed up or treated at any other branches too.
                </p>
              </div>

              {/* Socials */}
              <div className="flex items-center gap-3">
                <SocialIcon type="facebook" href="https://www.facebook.com/cliniqueinternational/" />
                <SocialIcon type="instagram" href="https://www.instagram.com/clinique_internationale/" />
                <SocialIcon type="youtube" href="https://www.youtube.com/@CliniqueHairSciencesofficial/videos" />
              </div>
            </div>

            {/* ── COLUMN 2: Our Treatments ── */}
            <div>
              <div className="flex items-center gap-3 mb-5">
                <span style={{ width: "3px", height: "18px", background: "#c9a84c", display: "inline-block" }} />
                <h4
                  className="uppercase"
                  style={{ fontFamily: "'Cinzel', serif", fontSize: "15px", letterSpacing: "0.06em", color: "#ffffff" }}
                >
                  Our Treatments
                </h4>
              </div>
              <ul className="flex flex-col gap-3">
{treatmentLinks.map((link, i) => (
  <li key={i}>
    <Link
      to={link.path}
      className="transition-colors duration-200 hover:text-[#c9a84c]"
      style={{
        fontFamily: "'Raleway', sans-serif",
        fontSize: "13.5px",
        fontWeight: 600,
        color: "#ffffff",
        textDecoration: "none",
      }}
    >
      {link.name}
    </Link>
  </li>
))}
              </ul>
            </div>

            {/* ── COLUMN 3: Other Links ── */}
            <div>
              <div className="flex items-center gap-3 mb-5">
                <span style={{ width: "3px", height: "18px", background: "#c9a84c", display: "inline-block" }} />
                <h4
                  className="uppercase"
                  style={{ fontFamily: "'Cinzel', serif", fontSize: "15px", letterSpacing: "0.06em", color: "#ffffff" }}
                >
                  Other Links
                </h4>
              </div>
              <ul className="flex flex-col gap-3" style={{ maxWidth: "260px" }}>
{otherLinks.map((link, i) => (
  <li key={i}>
    <Link
      to={link.path}
      className="transition-colors duration-200 hover:text-[#c9a84c]"
      style={{
        fontFamily: "'Raleway', sans-serif",
        fontSize: "13.5px",
        fontWeight: 600,
        color: "#ffffff",
        textDecoration: "none",
        lineHeight: 1.5,
      }}
    >
      {link.name}
    </Link>
  </li>
))}
              </ul>
            </div>

          </div>

          {/* ── COPYRIGHT DIVIDER ── */}
          <div className="mt-12 pt-6" style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }}>
            <p style={{ fontFamily: "'Raleway', sans-serif", fontSize: "12.5px", color: "rgba(255,255,255,0.35)" }}>
              Copyright © {new Date().getFullYear()}, Designed &amp; Developed by{" "}
              <a
                href="https://endurancetec.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#ffffff", fontWeight: 600, textDecoration: "none" }}
              >
                Endurance Tech
              </a>
            </p>
          </div>
        </div>

        
{/* ── IN YOUR CITY ── */}
<div style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }}>
  <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 py-10">

    <div className="flex items-center gap-3 mb-6">
      <span
        style={{
          width: "3px",
          height: "20px",
          background: "#c9a84c",
          display: "inline-block",
        }}
      />
      <h4
        className="uppercase"
        style={{
          fontFamily: "'Cinzel', serif",
          fontSize: "15px",
          letterSpacing: "0.06em",
          color: "#ffffff",
        }}
      >
        In Your City
      </h4>
    </div>

    <div
      className="max-h-[260px] overflow-y-auto pr-3 footer-city"
      style={{
        scrollbarWidth: "thin",
        scrollbarColor: "#c9a84c #17130d",
      }}
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {footerLocationGroups.map((group) => (
          <div key={group.title}>
            <h5
              style={{
                fontFamily: "'Cinzel', serif",
                fontSize: "11px",
                letterSpacing: "0.05em",
                color: "#c9a84c",
                marginBottom: "12px",
              }}
            >
              {group.title}
            </h5>

            <ul className="flex flex-col gap-2.5">
              {group.cities.map((city) => {
                const slug = city
                  .toLowerCase()
                  .replace(/\s*\(.*?\)\s*/g, "")
                  .replace(/&/g, "and")
                  .replace(/\s+/g, "-");

                return (
                  <li key={city}>
                    <Link
                      to="#" //{`/hair-transplant-in-${slug}`}
                      className="text-white/60 hover:text-[#c9a84c] transition-colors duration-200"
                      style={{
                        fontFamily: "'Raleway', sans-serif",
                        fontSize: "12.5px",
                        lineHeight: 1.6,
                        textDecoration: "none",
                      }}
                    >
                      Hair Transplant in {city}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    </div>

    <p
      className="mt-3 text-right"
      style={{
        fontFamily: "'Raleway', sans-serif",
        fontSize: "10px",
        color: "rgba(255,255,255,0.35)",
      }}
    >
      Scroll to explore all locations ↓
    </p>

  </div>
</div>


        {/* ── CONTACT INFO STRIP ── */}
        <div style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }}>
          <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 py-12">
            <div className="flex items-center gap-3 mb-8">
              <span style={{ width: "3px", height: "18px", background: "#c9a84c", display: "inline-block" }} />
              <h4
                className="uppercase"
                style={{ fontFamily: "'Cinzel', serif", fontSize: "15px", letterSpacing: "0.06em", color: "#ffffff" }}
              >
                Contact Info
              </h4>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {contactCards.map((c, i) => (
                <div
                  key={i}
                  className="rounded-xl p-5 transition-colors duration-200 hover:border-[#c9a84c]/40"
                  style={{ border: "1px solid rgba(255,255,255,0.08)", background: "rgba(255,255,255,0.02)" }}
                >
                  <div className="flex items-center gap-2 mb-3">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#c9a84c" strokeWidth={1.8}>
                      <path d="M12 21s-7-7.2-7-12a7 7 0 1114 0c0 4.8-7 12-7 12z" strokeLinejoin="round"/>
                      <circle cx="12" cy="9" r="2.4"/>
                    </svg>
                    <p style={{ fontFamily: "'Cinzel', serif", fontSize: "13px", color: "#c9a84c", letterSpacing: "0.03em" }}>
                      {c.city}
                    </p>
                  </div>
                  <p style={{ fontFamily: "'Raleway', sans-serif", fontSize: "12.5px", color: "rgba(255,255,255,0.45)", lineHeight: 1.65, marginBottom: "10px" }}>
                    {c.address}
                  </p>
                  {/* Display multiple phones if available, otherwise single phone */}
                  <div className="flex flex-col gap-2">
                    {c.phones ? (
                      c.phones.map((phone, idx) => (
                        <a
                          key={idx}
                          href={`tel:${phone.replace(/\s/g, "")}`}
                          className="flex items-center gap-2 transition-colors duration-200 hover:text-[#c9a84c]"
                          style={{ fontFamily: "'Raleway', sans-serif", fontSize: "13px", fontWeight: 500, color: "#ffffff", textDecoration: "none" }}
                        >
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                            <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
                          </svg>
                          {phone}
                        </a>
                      ))
                    ) : (
                      <a
                        href={`tel:${c.phone.replace(/\s/g, "")}`}
                        className="flex items-center gap-2 transition-colors duration-200 hover:text-[#c9a84c]"
                        style={{ fontFamily: "'Raleway', sans-serif", fontSize: "13px", fontWeight: 500, color: "#ffffff", textDecoration: "none" }}
                      >
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                          <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
                        </svg>
                        {c.phone}
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </footer>

{/* ── FLOATING ACTION BUTTONS ── */}
<div className={`fixed left-5 bottom-5 z-50 flex flex-col gap-3 transition-opacity duration-300 ${showFloating ? "opacity-100" : "opacity-0 pointer-events-none"}`}>
  <a
    href="tel:+919082123009"
    className="flex items-center justify-center rounded-full shadow-lg transition-transform duration-200 hover:scale-110"
    style={{ width: "52px", height: "52px", background: "#c9a84c" }}
  >
    <svg width="22" height="22" viewBox="0 0 24 24" fill="#0a0805">
      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
    </svg>
  </a>
  <a
    href={whatsappLink}
    target="_blank"
    rel="noopener noreferrer"
    className="flex items-center justify-center rounded-full shadow-lg transition-transform duration-200 hover:scale-110"
    style={{ width: "52px", height: "52px", background: "#c9a84c" }}
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="#0a0805">
      <path d="M17.6 6.32A8.86 8.86 0 0012.05 4a8.94 8.94 0 00-7.74 13.4L3 21l3.72-1.27a8.93 8.93 0 004.33 1.1h.01c4.94 0 8.94-4 8.94-8.94 0-2.38-.93-4.62-2.4-6.31zM12.06 19.1h-.01a7.42 7.42 0 01-3.79-1.04l-.27-.16-2.81.96.95-2.74-.18-.28a7.4 7.4 0 01-1.14-3.95 7.42 7.42 0 0112.65-5.25 7.36 7.36 0 012.17 5.25c0 4.1-3.34 7.44-7.44 7.44l-.13-.03zm4.08-5.57c-.22-.11-1.32-.65-1.53-.73-.2-.07-.35-.11-.5.11-.15.22-.58.73-.71.88-.13.15-.26.16-.49.05a6.07 6.07 0 01-1.78-1.1 6.65 6.65 0 01-1.23-1.53c-.13-.22 0-.34.11-.46.11-.13.25-.31.37-.46a.5.5 0 00.06-.5c-.07-.18-.5-1.2-.68-1.65-.18-.43-.36-.37-.49-.38h-.42a.82.82 0 00-.59.28 2.5 2.5 0 00-.78 1.86c0 1.1.8 2.16.91 2.31.11.15 1.56 2.38 3.78 3.24 2.22.86 2.22.57 2.62.53.4-.04 1.32-.54 1.51-1.06.18-.52.18-.96.13-1.06-.05-.1-.2-.16-.42-.27z"/>
    </svg>
  </a>
</div>

{/* Scroll to top */}
{showScrollTop && (
  <button
    onClick={scrollToTop}
    className="fixed right-5 bottom-5 z-50 flex items-center justify-center rounded-full shadow-lg transition-all duration-200 hover:scale-110"
    style={{ width: "50px", height: "50px", background: "#c9a84c" }}
  >
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0a0805" strokeWidth={2.3}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 19V5M5 12l7-7 7 7"/>
    </svg>
  </button>
)}
    </>
  );
}